import { api } from "constants/RotasAPI";
import { useMutation } from "react-query";
import { toast } from "react-hot-toast";
import { http } from "shared/util/http";
import { CadastroContasPagarParceladaGroupPayRequest } from "types/request/groupPay/CadastroContasPagarParceladaGroupPayRequest";

export const usePostCadastrarParceladaUnicaGroupPay = () => {
  const mutationFn = async (requestData: CadastroContasPagarParceladaGroupPayRequest): Promise<void> => {
    await http.post(api.contasPagar.postCadastrarDespesaParceladaGroupPay, requestData);
  };

  return useMutation(mutationFn, {
    onSuccess: () => {
      toast.success("Despesa cadastrada com sucesso!");
    },
    onError: (error: any) => {
      const groupCode = error?.response?.data?.validation?.[0]?.groupCode;
      const message = error?.response?.data?.validation?.[0]?.message;

      if (groupCode === "contasPagar.error.impostoSemConfig") {
        toast.error(
          message ||
            "Para cadastrar a retenção, você precisa vincular uma classe de conta a todos os impostos nos parâmetros."
        );
      } else if (groupCode === "contasPagar.error.dataInferior") {
        toast.error(message || "A data da baixa não pode ser inferior à data do saldo inicial da conta.");
      } else {
        toast.error(message || "Erro ao cadastrar despesa");
      }
    },
  });
};
